/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST

export const queryUserOderStatApi = params => {
  return axios.post(`${base}/user_order_stat/query`, params)
}
export const getUserOderStatDetailApi = params => {
  return axios.get(`${base}/user_order_stat/${params.id}`, {params})
}

export const userAddTagBySearchApi = params => {
  return axios.post(`${base}/user_order_stat/add_tag_by_search`, params)
}

export const userDelTagBySearchApi = params => {
  return axios.post(`${base}/user_order_stat/del_tag_by_search`, params)
}



// WEBPACK FOOTER //
// ./src/views/user-order-stat/userOrderStat.api.js